/**
 * Button.jsx
 * Botón corporativo con variantes: primary (azul), secondary (contorno), danger (rojo)
 * Estado loading con spinner CSS animado.
 *
 * Props:
 *   variant   'primary' | 'secondary' | 'danger'  (default: 'primary')
 *   loading   boolean
 *   children  ReactNode
 *   ...rest   pasan a <button>
 */
import styles from './Button.module.css';

const Button = ({
  variant = 'primary',
  loading = false,
  children,
  className = '',
  ...rest
}) => {
  const variantClass = styles[variant] ?? styles.primary;

  return (
    <button
      className={`${styles.btn} ${variantClass} ${className}`}
      disabled={loading || rest.disabled}
      {...rest}
    >
      {loading && <span className={styles.spinner} aria-hidden="true" />}
      {children}
    </button>
  );
};

export default Button;
